import React, { memo } from 'react';
import styles from './area-of-expertise.module.scss';
import CommonLoading from '../CommonLoading/CommonLoading';

const AreaOfExpertise = ({ areaOfExpertise, loading }) => {
  return (
    <div className={styles.SectionPlan}>
      <div className={styles.SectionName}>
        <span>Areas of Expertise</span>
      </div>
      {loading && (
        <div style={{ width: '785.04px' }} className="d-flex justify-content-center">
          <CommonLoading />
        </div>
      )}
      {!loading && <div className={styles.SectionContent} dangerouslySetInnerHTML={{ __html: areaOfExpertise }} />}
    </div>
  );
};

export default memo(AreaOfExpertise);
